import { AccordionHeaderIcon } from "./AccordionHeaderIcon";
import { AccordionHeaderRoot } from "./AccordionHeaderRoot";

export const AccordionHeader = {
  Root: AccordionHeaderRoot,
  Icon: AccordionHeaderIcon,
};
